import { INSTALLATION_ORDER_CANCELLED_STATUS_CODE } from "components/Installationstatus";
import { SALES_ORDER_CANCELLED_STATUS_CODE } from "components/SalesOrderstatus";

/**
 * Whether public Pay UI should treat the order as cancelled / closed (no payment).
 */
export function isPublicOrderCancelledForSummary(
  status: unknown,
  isRemovalPublicSummary: boolean,
  isInstallationPublicSummary: boolean
): boolean {
  const raw = status;
  const st = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(st)) return false;
  if (isRemovalPublicSummary) return st === 700 || st === 800;
  if (isInstallationPublicSummary) return st === INSTALLATION_ORDER_CANCELLED_STATUS_CODE;
  return st === SALES_ORDER_CANCELLED_STATUS_CODE;
}
